import { Routes } from '../const';
import { useMainContext } from '../context';
import { Status } from '../typings/paymentPlans';
import useTranslation from './use-translation';
var usePaymentOptions = function (settlement, plan, navigateTo) {
    var _a, _b, _c;
    var i18n = useTranslation();
    var setCurrentRoute = useMainContext().setCurrentRoute;
    var isPlanActive = ((_a = plan === null || plan === void 0 ? void 0 : plan.data) === null || _a === void 0 ? void 0 : _a.eligibilityStatus) === Status.Success &&
        !((_b = plan === null || plan === void 0 ? void 0 : plan.data) === null || _b === void 0 ? void 0 : _b.sameDayStatus);
    var isSettlementActive = (_c = settlement === null || settlement === void 0 ? void 0 : settlement.data) === null || _c === void 0 ? void 0 : _c.eligible;
    return [
        {
            heading: i18n('paymentOptions.oneTimePaymentCardHeading'),
            text: i18n('paymentOptions.oneTimePaymentCardSubHeading'),
            button: i18n('paymentOptions.oneTimePaymentCardButton'),
            onClick: function () { return navigateTo('payment'); },
            isActive: true
        },
        {
            heading: i18n('paymentOptions.customerAssistanceCardHeading'),
            text: i18n('paymentOptions.customerAssistanceCardSubHeading'),
            button: i18n('paymentOptions.customerAssistanceCardButton'),
            onClick: function () {
                setCurrentRoute(Routes.PLAN_START);
            },
            isActive: isPlanActive
        },
        {
            heading: i18n('paymentOptions.settlementCardHeading'),
            text: i18n('paymentOptions.settlementCardSubHeading'),
            button: i18n('paymentOptions.settlementCardButton'),
            onClick: function () {
                setCurrentRoute(Routes.SETTLEMENT_START);
            },
            isActive: isSettlementActive
        }
    ];
};
export default usePaymentOptions;
//# sourceMappingURL=use-payment-options.js.map